import React from "react";

const PrevEvalSelect = ({ prevEvalCode, prevEvals, handleChange }) => {   
    return (
        <>
            <div className="input-field">
                <div className="top-input">
                    Evaluation
                    <div className="required">
                        *
                    </div>
                </div>
                <select className="metric-select docker-select" value={prevEvalCode} onChange={(e) => {handleChange(e.target.value)}}>
                    <option key={''} value={''}>
                        None
                    </option>
                    {
                        prevEvals && prevEvals.length > 0 && (
                            prevEvals?.map((evaluation) => {
                                return (
                                    <option key={evaluation.assessmentCode} value={evaluation.assessmentCode}>
                                        {evaluation.name}
                                    </option>
                                )                    
                            })
                        )
                        
                    }
                </select>
            </div>
        </>
    );
}

export default PrevEvalSelect;